import { useGetMooringLine, useUpdateMooringLine } from "../api/api";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { LineDetailsPartial } from "./LineDetailsPartial";

type LineDetailsEditRouteProps = {
  match: {
    params: {
      shipId: string;
      lineId: string;
    };
  };
};

type CablePayload = {
  id?: number | string;
  tag?: string;
} & Record<string, unknown>;

type ApiError = {
  message?: Record<string, unknown>;
};

export const LineDetailsEdit = (props: LineDetailsEditRouteProps) => {
  const { shipId, lineId: cableId } = props.match.params;

  const history = useHistory();

  const { data: cable } = useGetMooringLine(shipId, cableId) as {
    data?: CablePayload;
  };

  const [editedCable, setEditedCable] = useState<CablePayload | undefined>();
  const [error, setError] = useState<ApiError | undefined>();

  useEffect(() => {
    if (!editedCable) {
      setEditedCable(cable);
    }
    // eslint-disable-next-line
  }, [cable]);

  const editCable = useUpdateMooringLine(shipId, cableId, {
    onSuccess: () => {
      if (history.length > 0) {
        history.goBack();
      } else {
        history.push(`/ships/${shipId}/lines/${cable?.id ?? cableId}/`);
      }
    },
    onError: ((err: ApiError) => setError(err)) as () => void,
  }) as unknown as {
    mutate: (payload: CablePayload | undefined) => void;
  };

  return (
    <LineDetailsPartial
      title={`Line #${cable?.tag}`}
      backLink={cable && `/ships/${shipId}/lines/${cableId}/`}
      submitButtonTitle="Save"
      editedCable={editedCable}
      error={error}
      setEditedCable={setEditedCable}
      onSubmitClick={() => {
        editCable.mutate(editedCable);
      }}
    />
  );
};
